
import { AlertTriangle } from 'lucide-react'
import { FaFileExcel } from "react-icons/fa";
import ExcelJS from "exceljs";
import { format } from "date-fns";
import { Button } from '../../ui/button';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '../../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Campanha, useOperador } from "../../../../context/OperadorContext";
import { useEffect, useState } from 'react';

interface ModalRelatoriosWhatsProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ModalRelatoriosWhats({ open, onOpenChange, }: ModalRelatoriosWhatsProps) {
  const { campanhas, getRelatorioCampanha } = useOperador()

  const [selectedCampanha, setSelectedCampanha] = useState<Campanha>({} as Campanha)

  useEffect(() => {
    if (!open) {
      setSelectedCampanha({} as Campanha)
    }
  }, [open])

  async function downloadCSV() {
    const { campanha, item_campanha } = await getRelatorioCampanha(selectedCampanha.id_campanha || 0) as unknown as { campanha: Campanha, item_campanha: { cpf_cnpj: string, telefone: string, status: string, data_campanha: string }[] }
    const rightAlign = [6, 7];
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Relatório Envio WhatsApp");
    const header = sheet.addRow([
      "CPF/CNPJ",
      "Telefone",
      'Data Hora Envio',
      "Status",
      "Nome Template",
      'Qtd. Envios',
      'Custo Total',
    ])
    header.eachCell((cell) => {
      cell.style = {
        font: {
          bold: true,
        },
      };
    });

    sheet.addRow([
      `TOTAL CAMPANHA ${campanha.id_campanha}`,
      `LOJA - ${campanha.cod_empresa_gazin}`,
      format(new Date(campanha.data_hora_criacao), 'dd/MM/yyyy HH:mm:ss'),
      campanha.status ? 'Ativa' : 'Finalizada',
      campanha.template,
      campanha.quant_envio,
      campanha.custo,

    ])
    sheet.addRow([
      '',
      '',
      '',
      '',
      '',
    ])
    for (const item of item_campanha) {
      sheet.addRow([
        item.cpf_cnpj,
        item.telefone,
        item.data_campanha ? format(new Date(item.data_campanha), 'dd/MM/yyyy HH:mm:ss') : '',
        item.status
      ])
    }
    sheet.eachRow((row) => {
      row.eachCell((cell, col) => {
        if (rightAlign.includes(col)) {
          cell.alignment = { horizontal: "right" };
        } else {
          cell.alignment = { horizontal: "left" };
        }
      });
    });
    sheet.columns.forEach((column) => {
      const lengths = column?.values?.map((v) => (v ?? 0).toString().length);
      const maxLength = Math.max(
        ...(lengths ?? []).filter((v) => typeof v === "number")
      );

      column.width = maxLength + 5;
      column?.eachCell &&
        column.eachCell((cell) => {
          cell.font = {
            ...cell.font,
            name: "Calibri",
          };
        });
    });

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const date = new Date().getDate();
        link.setAttribute("download", `Relatório Envio WhatsApp ${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error generating Excel file:", error);

      })

  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>

      <DialogContent className="flex items-center flex-col gap-4 w-full">
        <DialogHeader>
          <DialogTitle>Qual campanha deseja baixar?</DialogTitle>
        </DialogHeader>
        <Select
          onValueChange={(value) => {
            const campanha = campanhas.find(
              (c) => c.id_campanha === Number(value)
            )

            if (campanha) {
              setSelectedCampanha(campanha)
            }
          }}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Selecione a campanha" />
          </SelectTrigger>

          <SelectContent>
            <SelectGroup>
              <SelectLabel>Campanhas</SelectLabel>

              {campanhas.map((campanha) => (
                <SelectItem
                  key={campanha.id_campanha}
                  value={String(campanha.id_campanha)}
                >
                  <div className="flex flex-col text-left">
                    <span className="font-medium">
                      Campanha #{campanha.id_campanha}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {format(
                        new Date(campanha.data_hora_criacao),
                        'dd/MM/yyyy HH:mm'
                      )}{' '}
                      • {campanha.quant_envio} envios
                    </span>
                  </div>
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>

        <Button
          className="w-full"
          variant="outline"
          disabled={!selectedCampanha.id_campanha}
          onClick={downloadCSV}
        >
          Baixar Relatório
        </Button>

      </DialogContent>
    </Dialog>
  )
};
